import { useRecoilState } from 'recoil';
import { navIndex } from '../lib/atoms';
import './NavBar.css';

export default function NavBar() {
    const [selectedIndex, setSelectedIndex] = useRecoilState(navIndex);

    const navItems = [
        { id: 0, label: 'Info' },
        { id: 1, label: 'NPCs' },
        { id: 2, label: 'Bestiary' },
        { id: 3, label: 'Other' },
    ];

    return <nav>
        <ul>
            {navItems.map(item => <li key={item.id}
                onClick={() => setSelectedIndex(item.id)}
                className={item.id === selectedIndex ? 'selected' : ''}>
                {item.label}
            </li>)}
        </ul>
    </nav>;
}